import type { Piece } from "../content";

type Props = {
  piece: Piece;
  eager?: boolean;
  className?: string;
};

// Double-bezel media frame: hairline outer shell, concentric inner core.
export function Frame({ piece, eager, className = "" }: Props) {
  return (
    <div className={`group rounded-2xl bg-white/[0.04] p-1 ring-1 sm:rounded-[1.25rem] sm:p-1.5 ring-white/10 ${className}`}>
      <div
        className="overflow-hidden rounded-xl sm:rounded-[calc(1.25rem-0.375rem)] bg-ash shadow-[inset_0_1px_1px_rgba(255,255,255,0.12)]"
        style={{ aspectRatio: `${piece.width} / ${piece.height}` }}
      >
        <img
          src={piece.src}
          alt={piece.title}
          width={piece.width}
          height={piece.height}
          loading={eager ? "eager" : "lazy"}
          fetchPriority={eager ? "high" : undefined}
          decoding="async"
          className="h-full w-full object-cover transition-transform duration-[900ms] ease-heavy group-hover:scale-105"
        />
      </div>
    </div>
  );
}
